// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"f4021b47","462":"49546493","556":"c77ebb44","636":"3dc324ea","759":"29a0a8b8","797":"6e0780a6","798":"f4021b47","843":"5862de48","848":"9f1b9655","970":"0739455f"}[chunkId] + ".chunk.css";
};